var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-suggest search-suggest--sp"},[(_vm.search_candidate_active)?_c('search-candidates'):_vm._e(),_vm._v(" "),(_vm.search_suggestion_active)?_c('keyword-suggestions'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }